export default __webpack_public_path__ + "static/media/twitter-icon.f0449b70.svg";